import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import axiosInstance from '../../utils/axiosConfig';
import { PJ_BACKEND_URL } from '../../ConfigVars';

export const initiateSession = createAsyncThunk(
  'INITIATE_SESSION',
  async (_, { rejectWithValue }) => {
    const url = '/auth/create-session';
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },

);

export const checkReservation = createAsyncThunk(
  'CHECK_RESERVATION_BY_LASTNAME',
  async ({
    uniqueId, hotelId, roomId, lastname,
  }, { rejectWithValue }) => {
    const url = `/hotel/${uniqueId}/${hotelId}/reservation/${roomId}/lastname/${lastname}`;
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },

);

export const getHotelInformation = createAsyncThunk(
  'GET_HOTEL_INFORMATION',
  async ({ uniqueId, hotelId }, { rejectWithValue }) => {
    const url = `/hotel/${uniqueId}/${hotelId}/information`;
    if (uniqueId && hotelId) {
      try {
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  },
);

export const getHotelRooms = createAsyncThunk(
  'GET_HOTEL_ROOMS',
  async ({ uniqueId, hotelId }, { rejectWithValue }) => {
    const url = `/hotel/${uniqueId}/${hotelId}/all-rooms`;
    if (uniqueId && hotelId) {
      try {
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  },
);

export const getRoomInformation = createAsyncThunk(
  'GET_ROOM_INFORMATION',
  async ({ hotelId, roomId }, { rejectWithValue }) => {
    const url = `/hotel/${hotelId}/room/${roomId}`;
    if (roomId) {
      try {
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        console.log(error);
        return rejectWithValue(error.response.data);
      }
    }
  },
);

export const getReservation = createAsyncThunk(
  'GET_RESERVATION',
  async ({ uniqueId, hotelId, roomId }, { rejectWithValue }) => {
    const url = `/hotel/${uniqueId}/${hotelId}/reservation/${roomId}`;
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getFoliosOfReservation = createAsyncThunk(
  'GET_FOLIOS_OF_RESERVATION',
  async ({ uniqueId, reservationId }, { rejectWithValue }) => {
    const url = `/hotel/${uniqueId}/folios/reservation/${reservationId}`;
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getSingleFolio = createAsyncThunk(
  'GET_SINGLE_FOLIO',
  async ({ folioId }, { rejectWithValue }) => {
    const url = `/hotel/folios/${folioId}`;
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getMultipleFolios = createAsyncThunk(
  'GET_MULTIPLE_FOLIOS',
  async ({ hotelId, folioIds }, { rejectWithValue }) => {
    try {
      const promises = [];
      const responses = [];
      if (folioIds.length > 0) {
        folioIds.map((id) => {
          const url = `${PJ_BACKEND_URL}hotel/${hotelId}/folios/${id}`;
          promises.push(
            axios.get(url, {
              headers: {
                authorization: btoa(
                  JSON.stringify({ username: 'user', password: 'WU67W=<h[Hy!7[+7' }),
                ),
              },
            }),
          );
        });
        const values = await Promise.all(promises);
        values.forEach((value) => {
          responses.push(value.data);
        });
        return responses;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getPaymentMethods = createAsyncThunk(
  'GET_PAYMENT_METHODS',
  async ({ hotelId }, { rejectWithValue }) => {
    const url = `/payment/${hotelId}/payment-methods`;
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const changeFolioAddress = createAsyncThunk(
  'CHANGE_FOLIO_ADDRESS',
  async ({
    hotelId, propertyId, folioId, values,
  }, { rejectWithValue }) => {
    const url = `/hotel/${hotelId}/folio-address`;
    const data = {
      billingAddressType: values.billingAddressType,
      propertyId,
      debitor: {
        title: values.title,
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        addressLine1: values.addressLine1,
        addressLine2: values.addressLine2,
        postalCode: values.postalCode,
        city: values.city,
        countryCode: 'DE',
        additionalInformation: values.additionalInformation,
      },
      folioId,
    };
    try {
      const response = await axiosInstance.put(url, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const changeInvoiceAddress = createAsyncThunk(
  'CHANGE_INVOICE_ADDRESS',
  async ({
    hotelId, propertyId, folioId, values,
  }, { rejectWithValue }) => {
    const url = `/hotel/${hotelId}/invoice-address`;
    const data = {
      propertyId,
      debitor: {
        title: values.title,
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        addressLine1: values.addressLine1,
        addressLine2: values.addressLine2,
        postalCode: values.postalCode,
        city: values.city,
        countryCode: 'DE',
        additionalInformation: values.additionalInformation,
      },
      folioId,
    };
    try {
      const response = await axiosInstance.put(url, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const createPaymentSession = createAsyncThunk(
  'CREATE_SESSION',
  async ({ hotelId, amount }, { rejectWithValue }) => {
    const url = `/payment/${hotelId}/create-session`;
    const data = {
      amount,
    };
    try {
      const response = await axiosInstance.post(url, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const makePaymentByAuthorization = createAsyncThunk(
  'INITIALIZE_PAYMENT',
  async ({
    hotelId, amount, paymentMethod, folios, tip,
  }, { rejectWithValue }) => {
    const url = `/payment/${hotelId}/pay-by-authorization`;
    const data = {
      folios,
      tip,
      amount,
      paymentMethod,
    };
    try {
      const response = await axiosInstance.post(url, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const createNewFolio = createAsyncThunk(
  'CREATE_FOLIO',
  async (
    {
      hotelId, reservationId, folioId, debitor, chargeIds, type,
    },
    { rejectWithValue },
  ) => {
    const url = `hotel/${hotelId}/folios/create`;
    const data = {
      reservationId,
      debitor,
      type,
    };
    try {
      const response = await axiosInstance.post(url, data);
      const secondUrl = `hotel/${hotelId}/folios/${folioId}/move-charges`;
      const targetFolioId = response.data;
      const secondData = {
        folioId,
        targetFolioId,
        chargeIds,
      };
      try {
        await axiosInstance.put(secondUrl, secondData);
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const addTransitoryCharge = createAsyncThunk(
  'ADD_TRANSITORY_CHARGE',
  async ({
    hotelId, folioIds, tip, receipt,
  }, { rejectWithValue }) => {
    let folioId;
    if (folioIds.indexOf(',') > -1) {
      const folioIdsArray = folioIds.split(',');
      folioId = folioIdsArray[0];
    } else folioId = folioIds;

    const url = `hotel/${hotelId}/folios/${folioId}/transitory-charges`;

    const data = {
      name: 'Tip',
      amount: {
        amount: tip,
        currency: 'EUR',
      },
      receipt,
    };
    try {
      const response = await axiosInstance.post(url, data);
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response.data);
    }
  },
);

export const getFolioInvoicePreview = createAsyncThunk(
  'GET_FOLIO_INVOICE_PREVIEW',
  async ({ hotelId, folioIds }, { rejectWithValue }) => {
    try {
      const promises = [];
      const responses = [];
      if (Array.isArray(folioIds)) {
        folioIds.map((id) => {
          if (id !== undefined) {
            const url = `/hotel/${hotelId}/folios/${id}/invoice`;
            promises.push(axiosInstance.get(url));
          }
        });
      } else if (folioIds !== undefined) {
        const url = `/hotel/${hotelId}/folios/${folioIds}/invoice`;
        promises.push(axiosInstance.get(url));
      }
      if (promises.length > 0) {
        const values = await Promise.all(promises);
        values.forEach((value) => {
          responses.push(value.data);
        });
      }
      return responses;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const makePaymentByAccount = createAsyncThunk(
  'MAKE_PAYMENT_BY_AUTHENTICATION',
  async ({ hotelId, folioIds, tip }, { rejectWithValue }) => {
    const url = `/payment/${hotelId}/pay-by-account`;
    const data = {
      folios: JSON.stringify(folioIds),
      tip,
    };
    try {
      if (folioIds !== 'null') {
        const response = await axiosInstance.post(url, data);
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const closeFolios = createAsyncThunk(
  'CLOSE_FOLIOS',
  async ({ hotelId, folioIds }, { rejectWithValue }) => {
    try {
      const promises = [];
      const responses = [];
      folioIds.map((id) => {
        const url = `${PJ_BACKEND_URL}hotel/${hotelId}/folios/${id}/close`;
        promises.push(
          axios.put(url, null, {
            headers: {
              authorization: btoa(
                JSON.stringify({ username: 'user', password: 'WU67W=<h[Hy!7[+7' }),
              ),
            },
          }),
        );
      });
      const values = await Promise.all(promises);
      values.forEach((value) => {
        responses.push(value.data);
      });
      return responses;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const setCurrentFolioIds = createAsyncThunk(
  'SET_CURRENT_FOLIOS',
  async ({ folioIds }) => folioIds,
);
export const setCurrentTip = createAsyncThunk('SET_CURRENT_TIP', async ({ tip }) => tip);
export const checkout = createAsyncThunk(
  'CHECKOUT',
  async ({ hotelId, reservationId }, { rejectWithValue }) => {
    const url = `/hotel/${hotelId}/reservation/${reservationId}/checkout`;
    try {
      const response = await axiosInstance.put(url, {});
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const sendEvent = createAsyncThunk(
  'SEND_CHECKOUT_TIME',
  async ({ roomId, reservationId, type }, { rejectWithValue }) => {
    const url = '/event/create';
    try {
      const data = {
        roomId,
        reservationId,
        type,
      };
      const response = await axiosInstance.post(url, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getInvoicesByReservationId = createAsyncThunk(
  'GET_INVOICES_BY_RESERVATION_ID',
  async ({ hotelId, reservationId }, { rejectWithValue }) => {
    const url = `/hotel/${hotelId}/invoices/${reservationId}`;
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const createInvoice = createAsyncThunk(
  'CREATE_INVOICE',
  async ({ hotelId, folios }, { rejectWithValue }) => {
    const url = `/hotel/${hotelId}/invoices/create`;
    const data = {
      folios: JSON.stringify(folios),
    };
    try {
      const response = await axiosInstance.post(url, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const handleDownloadInvoice = createAsyncThunk(
  'DOWNLOAD_INVOICE',
  async ({ hotelId, invoiceIds }, { rejectWithValue }) => {
    const promises = [];
    const responses = [];
    try {
      invoiceIds.map((invoiceId) => {
        const url = `/hotel/${hotelId}/invoices/${invoiceId}/invoice-pdf`;
        promises.push(axiosInstance.get(url));
      });
      const values = await Promise.all(promises);
      values.forEach((value) => {
        responses.push(value.data);
      });
      return responses;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const sendInvoiceEmail = createAsyncThunk('SEND_INVOICE_EMAIL',
  async ({
    to, fullName, subject, hotelName, hotelId, invoiceIds,
  }, { rejectWithValue }) => {
    const url = '/mail/invoice';
    const data = {
      to,
      fullName,
      subject,
      hotelName,
      hotelId,
      invoiceIds,
    };
    try {
      const response = await axiosInstance.post(url, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  });

export const resetAll = createAsyncThunk('RESET_ALL', async () => {
  console.log('Reset done');
});
